import React from 'react';
import * as Portals from 'react-reverse-portal';

import PropTypes from 'prop-types';
import { portalNodeType } from '../../../util/sharedPropTypes';

const propTypes = {
  portalNode: portalNodeType,
  latitude: PropTypes.number,
  longitude: PropTypes.number,
  zoomLevel: PropTypes.number,
};

const defaultProps = {
  portalNode: null,
  latitude: 0,
  longitude: 0,
  zoomLevel: 1,
};

function SingleMapPin({ portalNode, latitude, longitude, zoomLevel }) {
  return (
    <div className="Component SingleMapPin">
      <div className="SingleMapPin">
        {portalNode && (
          <Portals.OutPortal
            node={portalNode}
            latitude={latitude}
            longitude={longitude}
            zoomLevel={zoomLevel}
          />
        )}
      </div>
    </div>
  );
}

SingleMapPin.propTypes = propTypes;
SingleMapPin.defaultProps = defaultProps;

export default SingleMapPin;
